<template>
    <b-card no-body>
        <b-modal id="create-or-update" title="Eksik Gün Eşleştir" no-close-on-esc no-close-on-backdrop>
            <sgk-eksik-gun-create-or-update v-model="eksikGun"></sgk-eksik-gun-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import SGKEksikGunCreateOrUpdate from './components/SGKEksikGunCreateOrUpdate.vue';
import HumanResourcesParametersApi from '@/api/human-resources-parameters';

export default {
    components:{
        BCard,
        'sgk-eksik-gun-create-or-update':SGKEksikGunCreateOrUpdate
    },
    data(){
        return {
            eksikGun:{
                Id: null,
                Code: null,
                Name: null,
                Description: null,
                EmployeeWorkingTypeId: null,
                Daily: true
            },
            loading:false,
            editing:false,
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            errors:{},
            fields:[
                {name:'Kod',key:'Code',thClass:'w-15'},
                {name:'Eksik Gün',key:'Name',thClass:'w-15'},
                {name:'Çalışma Gün Türü',key:'EmployeeWorkingTypeName',thClass:'w-15'},
                {name:'Açıklama',key:'Description',thClass:'w-55'},
                {name:'Günlük',key:'Daily'}
            ]
        }
    },
    methods:{
        provider(data){
            return HumanResourcesParametersApi.SGKEksikGun.Table(data)
        },
        clearForm(){
            this.editing =false
            this.eksikGun.Id = null
            this.eksikGun.Code = null
            this.eksikGun.Name = null
            this.eksikGun.Description = null
            this.eksikGun.EmployeeWorkingTypeId = null
            this.eksikGun.Daily = true
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.eksikGun.Id = item.Id
            this.eksikGun.Code = item.Code
            this.eksikGun.Name = item.Name
            this.eksikGun.Description = item.Description
            this.eksikGun.EmployeeWorkingTypeId = item.EmployeeWorkingTypeId
            this.eksikGun.Daily = item.Daily
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParametersApi.SGKEksikGun.CreateOrUpdate(this.editing,this.eksikGun).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.loading = false
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli eksik günü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParametersApi.SGKEksikGun.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>